/**
 * Calendar feature — UI-only presentation settings (three-bucket).
 */

export const CALENDAR_UI = {
  /** ISO weekdays (Mon..Sun) for the weekly recurrence picker. */
  WEEKDAY_LABELS: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'] as const,
  /** Time slots rendered in the day/week grid (24h). */
  TIME_SLOTS: [
    '08:00', '09:00', '10:00', '11:00', '12:00',
    '13:00', '14:00', '15:00', '16:00', '17:00',
    '18:00', '19:00', '20:00', '21:00',
  ] as const,
  /** Default colour for sessions when no per-subject colour is found. */
  DEFAULT_EVENT_COLOR: '#6366f1',
} as const;

export function formatHmInTz(iso: string, timezone: string): string {
  return new Date(iso).toLocaleTimeString('en-US', {
    timeZone: timezone,
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  });
}

